import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from "@angular/router";

import * as stageTypes from '../../types';
import * as _ from 'lodash';

import { QUESTION_TYPES, VENDOR_KEYS } from '../../types/constants';
import { Observable } from 'rxjs/Rx';
import { BaseFileTypeComponent } from '../base-file-type/base-file-type.component';
import { WindowRefService } from '../../../shared/services/window-ref.service';

@Component({
  selector: 'tr-block-element',
  templateUrl: './block-element.component.html',
  //styleUrls: ['./block-element.component.scss']
})
export class BlockElementComponent extends BaseFileTypeComponent<stageTypes.IHtmlElement> implements OnInit {
  // @Input() componentDef: stageTypes.IHtmlElement;
  // @Input() isDownloading$: Observable<boolean>;
  // @Input() currentAction$: Observable<string>;
  @Input() currentStageId: number;
  //@Output() action = new EventEmitter<string>();

  private actions: any[];
  private type: string;
  private gmapUrl: string;

  private googleMapkey: string = VENDOR_KEYS.GOOGLE_MAP;
  
  constructor(private sanitizer: DomSanitizer, private windowRef: WindowRefService, private route: ActivatedRoute, private router:Router) {
    super(windowRef);
  }

  ngOnInit() {
    super.ngOnInit();
    
    this.actions = this.componentDef['actions'] as stageTypes.IAction[];
    this.type = this.componentDef.type;
    this.gmapUrl = `//www.google.com/maps/embed/v1/place?key=${this.googleMapkey}&q=${this.componentDef.content}`;
  }

  getIco(action: stageTypes.IAction): string {
    return _.has(action, 'iconclass') ? action.iconclass : `ico-${action.name.toLowerCase()}`;
  }

  getTitle(): string {
    return (_.has(this.componentDef, 'showname') && this.componentDef['showname']) ?
      this.componentDef.name.substring(0, this.componentDef.name.lastIndexOf('.')) : this.componentDef.title;
  }

  // Type check
  isHtmlChunk() {
    return this.type === QUESTION_TYPES.HTML_CONTENT;
  }

  isFileBlock() {
    return this.type === QUESTION_TYPES.FILE_BLOCK;
  }

  isCalendar() {
    return this.type === QUESTION_TYPES.CALENDAR;
  }

  isSocialLink() {
    return this.type === QUESTION_TYPES.SOCIAL_LINK;
  }

  isGooglemap() {
    return this.type === QUESTION_TYPES.MAP;
  }

  isSimpleLink() {
    return this.type === QUESTION_TYPES.SIMPLE_LINK;
  }

  goLink(href) {
    this.router.navigate([href]);
  }

  
}



// WEBPACK FOOTER //
// ./src/app/stage/components/block-element/block-element.component.ts